import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../css/LandingPage.css";

const LandingPage = () => {
  const [showJBrowse, setShowJBrowse] = useState(false);

  const renderFullScreenJBrowse = () => {
    if (!showJBrowse) return null;

    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: '#000',
          zIndex: 9999,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '10px 20px',
            backgroundColor: '#1a1a1a',
            color: 'white',
          }}
        >
          <h3 style={{ margin: 0 }}>🗺️ JBrowse 2 Genome Viewer</h3>
          <button
            onClick={() => setShowJBrowse(false)}
            style={{
              background: '#4CAF50',
              border: 'none',
              color: 'white',
              padding: '8px 16px',
              borderRadius: '5px',
              cursor: 'pointer',
              fontWeight: 'bold',
              fontSize: '14px',
            }}
          >
            ⬅ Back to Landing Page
          </button>
        </div>

        <iframe
          src="/jbrowse-data/?config=config.json"
          title="JBrowse 2"
          style={{
            flexGrow: 1,
            width: '100%',
            height: '100%',
            border: 'none',
          }}
        />
      </div>
    );
  };

  if (showJBrowse) return renderFullScreenJBrowse();

  return (
    <div className="landing-container">
      <div className="landing-overlay">
        <div className="landing-content">
          <h1 className="landing-title">
            The Ethiopian Teff Genomics & Bioinformatics Portal
          </h1>

          <p className="landing-tagline">
            Empowering teff research through integrated genomics,
            bioinformatics, molecular biology resources, and advanced
            analytical tools for <i>Eragrostis tef</i>.
          </p>

          {/* BUTTONS */}
          <div className="landing-buttons">
            <Link to="/home" className="btn-primary">
              Explore Database
            </Link>

            <Link to="/about" className="btn-secondary">
              Project Overview
            </Link>
          </div>

          {/* FEATURE GRID */}
          <div className="feature-grid">
            {/* GENOMES */}
            <Link to="/genomeassembly" className="feature-card emoji-card">
              <span className="feature-emoji">🧬</span>
              <div>
                <h3>Genomes</h3>
                <p>Assemblies • BioProjects • BioSamples • SRA</p>
              </div>
            </Link>

            {/* LITERATURE */}
            <Link to="/pubmed" className="feature-card emoji-card">
              <span className="feature-emoji">📚</span>
              <div>
                <h3>Literature</h3>
                <p>PubMed • PMC • Bookshelf</p>
              </div>
            </Link>

            {/* BLAST */}
            <Link to="/blast" className="feature-card emoji-card">
              <span className="feature-emoji">⚡</span>
              <div>
                <h3>BLAST</h3>
                <p>Sequence Similarity Search</p>
              </div>
            </Link>

            {/* JBROWSE - NOW USING IFRAME MODAL */}
            <div
              onClick={() => setShowJBrowse(true)}
              className="feature-card emoji-card"
              style={{ cursor: 'pointer' }}
            >
              <span className="feature-emoji">🗺️</span>
              <div>
                <h3>JBrowse 2</h3>
                <p>Interactive Genome Browser</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
